const { find } = require('lodash');

class CategoriesNavigationController {
    constructor($element, categoriesService, analyticsService) {
        this.$element = $element;
        this.categoriesService = categoriesService;
        this.analyticsService = analyticsService;
    }

    $onInit() {
        this.classModifierName = this.classModifier ? `categoriesNavigation--${this.classModifier}` : '';
    }

    $onChanges() {
        this.specialCategory = this.getSpecialChild();
        this.bundleCategory = this.getBundleChild();
    }

    selectCategory(event, category) {
        if (this.onSelect) {
            this.onSelect({ event, category });
        }
    }

    isCurrentCategory(category) {
        const currentCategory = this.categoriesService.currentCategories.current;

        return category && currentCategory && currentCategory.NodeId === category.NodeId;
    }

    isActiveCategory(category) {
        if (!category) {
            return false;
        }
        return this.selected
            ? this.selected.NodeId === category.NodeId
            : this.categoriesService.currentCategories.isActive(category.NodeId);
    }

    getSpecialChild() {
        if (!(this.category && this.category.Children)) { return null; }

        if (!this.category.IsSpecial) {
            return find(this.category.Children, c => c.IsSpecial);
        }

        return null;
    }

    getBundleChild() {
        if (!(this.category && this.category.Children)) { return null; }

        return find(this.category.Children, c => c.IsBundle);
    }

    shouldDisplay(canShow) {
        return canShow
            && this.category
            && this.category.NodeLevel;
    }

    pushDataToAnalyticsService() {
        this.analyticsService.push({
            data: {
                trackingType: 'link',
            },
            type: this.analyticsService.mapperTypes.customEvent.menuClick,
        });
    }
}

/**
 * @ngdoc component
 * @name wowCategoriesNavigation
 *
 * Component which generates a list of navigation links from a given category.
 *
 * @param [classModifier] {string} Custom style class name.
 * @param [category] {Object} Category to render nav items for.
 * @param [selected] {Boolean} Is this category currently selected. Used for styling.
 * @param [shouldShowShowAll] {Boolean} Controls display of show all link.
 * @param [shouldShowSpecials] {Boolean} Controls display of specials link.
 * @param [shouldShowBundles] {Boolean} Controls display of bundles link.
 * @param [shouldShowSeparator] {Boolean} Controls display of a separator element.
 * @param [shouldShowArrow] {Boolean} Determine whether the arrow icon should show at the end of elements.
 * @param [onSelect] {Function} Custom callback function to fire when a link is clicked by the user. If not set, default is to navigate to the categories page.
 */
const categoriesNavigationComponentDefinition = {
    transclude: true,
    bindings: {
        classModifier: '@?',
        category: '<?',
        selected: '<?',
        shouldShowShowAll: '<?',
        shouldShowSpecials: '<?',
        shouldShowBundles: '<?',
        shouldShowSeparator: '<?',
        shouldShowArrow: '<?',
        onSelect: '&?',
    },
    controller: ['$element', 'CategoriesService', 'AnalyticsService', CategoriesNavigationController],
    template: require('./categories-navigation.component.html').trim(),
};

module.exports = {
    CategoriesNavigationController,
    categoriesNavigationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/categories/categories-navigation.component.js